import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import eventEmitter from "../utils/eventEmitter";
import { AuthContext } from "../store/ContextStore";
import localStorageService from "../services/localStorageService";
import { TEAM_SEAT_OVERFLOW } from "../constants/routes";

type TeamSeatOverflowEvent = {
  code?: string;
  message?: string;
};

const TEAM_SEAT_OVERFLOW_MESSAGE_KEY = "team_seat_overflow_message";

export default function TeamSeatOverflowModalManager() {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const selectedSport =
    (auth as any)?.selectedSport || localStorageService.getSelectedSport("");

  useEffect(() => {
    function handleTeamSeatOverflow(payload: TeamSeatOverflowEvent) {
      if (payload?.message) {
        localStorage.setItem(TEAM_SEAT_OVERFLOW_MESSAGE_KEY, String(payload.message));
      }
      navigate(TEAM_SEAT_OVERFLOW, { replace: true });
    }

    eventEmitter.on("team_seat_overflow", handleTeamSeatOverflow as any);
    return () => {
      eventEmitter.off("team_seat_overflow", handleTeamSeatOverflow as any);
    };
  }, [navigate, selectedSport]);

  return null;
}
